import { DiscountCalculationType } from '@vista-digital/ocapi-types/v1';
import { logger } from '../../../../utils/logger';
export const areDiscountItemPricesEquivalent = (prices) => {
    return prices.every(price => {
        if (price.discount.calculation.type !== prices[0].discount.calculation.type) {
            return false;
        }
        const discountCalculation = price.discount.calculation;
        const firstDiscountCalculationInArray = prices[0].discount.calculation;
        switch (discountCalculation.type) {
            case DiscountCalculationType.PercentageOff:
                return (discountCalculation.percentageOff ===
                    firstDiscountCalculationInArray.percentageOff);
            case DiscountCalculationType.PriceOff:
                return (discountCalculation.priceOff ===
                    firstDiscountCalculationInArray.priceOff);
            case DiscountCalculationType.SpecialPrice:
                return (discountCalculation.specialPrice ===
                    firstDiscountCalculationInArray.specialPrice);
            default:
                logger.warn(`Cannot compare price with unknown discount '${price.discount.calculation.type}'.`);
                return false;
        }
    });
};
